import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const NotificationsPanel = ({ isOpen, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const getToken = () => localStorage.getItem('wclub_admin_token');

  const scheduleEventReminders = async () => {
    setLoading(true);
    setResult(null);
    try {
      const res = await axios.post(`${API}/notifications/schedule-event-reminders`, {}, {
        headers: { Authorization: `Bearer ${getToken()}` }
      });
      setResult({ type: 'success', message: res.data.message });
    } catch (err) {
      setResult({ type: 'error', message: err.response?.data?.detail || 'Erro ao agendar' });
    }
    setLoading(false);
  };

  const sendPendingNotifications = async () => {
    setLoading(true);
    setResult(null);
    try {
      const res = await axios.post(`${API}/notifications/send-pending`, {}, {
        headers: { Authorization: `Bearer ${getToken()}` }
      });
      setResult({ type: 'success', message: res.data.message });
    } catch (err) {
      setResult({ type: 'error', message: err.response?.data?.detail || 'Erro ao enviar' });
    }
    setLoading(false);
  };

  const sendBirthdayNotifications = async () => {
    setLoading(true);
    setResult(null);
    try {
      const res = await axios.post(`${API}/notifications/send-birthday`, {}, {
        headers: { Authorization: `Bearer ${getToken()}` }
      });
      setResult({ 
        type: 'success', 
        message: res.data.count > 0 
          ? `🎂 ${res.data.birthday_members.join(', ')}` 
          : res.data.message 
      });
    } catch (err) {
      setResult({ type: 'error', message: err.response?.data?.detail || 'Erro ao enviar' });
    }
    setLoading(false);
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/85 backdrop-blur-sm flex items-center justify-center z-[80] p-4"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.95, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.95, opacity: 0, y: 20 }}
          onClick={(e) => e.stopPropagation()}
          className="rounded-2xl max-w-sm w-full border border-white/[0.1] backdrop-blur-xl overflow-hidden"
          style={{ background: 'linear-gradient(145deg, rgba(12,18,32,0.98) 0%, rgba(8,12,22,0.99) 100%)' }}
        >
          {/* Header */}
          <div className="p-5 border-b border-white/[0.06]">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-amber-500/15 border border-amber-500/25 rounded-xl flex items-center justify-center">
                  <svg className="w-5 h-5 text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-base font-['Jost'] font-semibold text-white/90">Notificações</h3>
                  <p className="text-xs text-white/40">Gerenciar lembretes</p>
                </div>
              </div>
              <button
                onClick={onClose}
                className="w-8 h-8 rounded-lg bg-white/[0.04] border border-white/[0.08] flex items-center justify-center text-white/40 hover:text-white/70 transition"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>

          {/* Actions */}
          <div className="p-4 space-y-3">
            <button
              onClick={scheduleEventReminders}
              disabled={loading}
              className="w-full p-4 bg-blue-500/10 border border-blue-500/20 rounded-xl text-left hover:bg-blue-500/15 transition disabled:opacity-50"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-blue-500/20 rounded-lg flex items-center justify-center">
                  <svg className="w-5 h-5 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-medium text-white/80">Agendar Lembretes</p>
                  <p className="text-xs text-white/40">1 dia e 2h antes dos eventos</p>
                </div>
              </div>
            </button>

            <button
              onClick={sendPendingNotifications}
              disabled={loading}
              className="w-full p-4 bg-green-500/10 border border-green-500/20 rounded-xl text-left hover:bg-green-500/15 transition disabled:opacity-50"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-green-500/20 rounded-lg flex items-center justify-center">
                  <svg className="w-5 h-5 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-medium text-white/80">Enviar Pendentes</p>
                  <p className="text-xs text-white/40">Notificações agendadas</p>
                </div>
              </div>
            </button>

            <button
              onClick={sendBirthdayNotifications}
              disabled={loading}
              className="w-full p-4 bg-purple-500/10 border border-purple-500/20 rounded-xl text-left hover:bg-purple-500/15 transition disabled:opacity-50"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-purple-500/20 rounded-lg flex items-center justify-center">
                  <span className="text-lg">🎂</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-white/80">Aniversariantes</p>
                  <p className="text-xs text-white/40">Verificar e notificar</p>
                </div>
              </div>
            </button>

            {/* Result message */}
            <AnimatePresence>
              {result && (
                <motion.div
                  initial={{ opacity: 0, y: 5 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0 }}
                  className={`p-3 rounded-xl text-sm ${
                    result.type === 'success' 
                      ? 'bg-green-500/10 border border-green-500/20 text-green-400' 
                      : 'bg-red-500/10 border border-red-500/20 text-red-400'
                  }`}
                >
                  {result.message}
                </motion.div>
              )}
            </AnimatePresence>

            {loading && (
              <div className="flex justify-center py-2">
                <div className="w-5 h-5 border-2 border-white/20 border-t-white/60 rounded-full animate-spin"></div>
              </div>
            )}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default NotificationsPanel;
